module.exports = __webpack_public_path__ + "img/marketing.2ae684bb.svg";